import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotificationHandlerService {

  constructor(
    private router: Router,
    private alertController: AlertController,
    private toastController: ToastController
  ) {}

  /**
   * Gérer l'ouverture d'une notification
   */
  async handleNotificationOpened(result: any): Promise<void> {
    const data = result.notification.payload.additionalData;
    const type = data?.type;

    console.log('🔔 Gestion notification:', data);

    switch(type) {
      case 'message':
        await this.handleMessageNotification(data);
        break;
      
      case 'order':
        await this.handleOrderNotification(data);
        break;
      
      case 'alert':
        await this.handleAlertNotification(result.notification.payload);
        break;
      
      case 'test':
        await this.handleTestNotification(data);
        break;
      
      default:
        await this.handleDefaultNotification(result.notification.payload);
    }
  }

  /**
   * Afficher un toast pour une notification reçue
   */
  async showNotificationToast(notification: any): Promise<void> {
    const toast = await this.toastController.create({
      header: notification.payload?.title || notification.title,
      message: notification.payload?.body || notification.body,
      duration: 4000,
      position: 'top',
      buttons: [
        {
          text: 'Voir',
          handler: () => {
            // Gérer l'action
            if (notification.payload?.additionalData) {
              this.handleNotificationOpened({ notification });
            }
          }
        },
        {
          text: 'Fermer',
          role: 'cancel'
        }
      ]
    });

    await toast.present();
  }

  private async handleMessageNotification(data: any): Promise<void> {
    const messageId = data.messageId || data.message_id;
    
    if (messageId) {
      this.router.navigate(['/messages', messageId]);
    } else {
      this.router.navigate(['/messages']);
    }
  }

  private async handleOrderNotification(data: any): Promise<void> {
    const orderId = data.orderId || data.order_id;
    
    if (orderId) {
      this.router.navigate(['/orders', orderId]);
    } else {
      this.router.navigate(['/orders']);
    }
  }

  private async handleAlertNotification(payload: any): Promise<void> {
    const alert = await this.alertController.create({
      header: payload.title,
      message: payload.body,
      buttons: ['OK']
    });

    await alert.present();
  }

  private async handleTestNotification(data: any): Promise<void> {
    const toast = await this.toastController.create({
      message: '✅ Notification de test reçue !',
      duration: 3000,
      color: 'success',
      position: 'bottom'
    });

    await toast.present();
  }

  private async handleDefaultNotification(payload: any): Promise<void> {
    const toast = await this.toastController.create({
      message: payload.body || 'Nouvelle notification',
      duration: 3000,
      position: 'top'
    });

    await toast.present();
  }
}